export const photoModeFilters = [
	{
		id: '',
		name: 'По умолчанию',
	},
	{
		id: 'NG_filmic01',
		name: 'Альбукерке',
	},
	{
		id: 'NG_filmic02',
		name: 'Gonzo',
	},
	{
		id: 'NG_filmic03',
		name: 'Катод',
	},
	{
		id: 'NG_filmic04',
		name: 'Печать зла',
	},
	{
		id: 'NG_filmic05',
		name: 'Нормандия',
	},
	{
		id: 'NG_filmic06',
		name: 'Эмульсия',
	},
	{
		id: 'NG_filmic07',
		name: 'Инферно',
	},
	{
		id: 'NG_filmic08',
		name: 'Пурпурная дымка',
	},
	{
		id: 'NG_filmic09',
		name: 'Sentinel',
	},
	{
		id: 'NG_filmic10',
		name: 'Кабуки-те',
	},
	{
		id: 'NG_filmic11',
		name: 'Ледник',
	},
	{
		id: 'NG_filmic12',
		name: 'Ночные ходы',
	},
	{
		id: 'NG_filmic13',
		name: 'Nueva Esperanza',
	},
	{
		id: 'NG_filmic14',
		name: 'Эй, девочка!',
	},
	{
		id: 'NG_filmic15',
		name: 'Ностальгия',
	},
	{
		id: 'NG_filmic16',
		name: 'Ночная смена',
	},
	{
		id: 'NG_filmic17',
		name: 'Тель-Авив',
	},
	{
		id: 'NG_filmic18',
		name: 'Высота кабины',
	},
	{
		id: 'NG_filmic19',
		name: 'Высокогорье',
	},
	{
		id: 'NG_filmic20',
		name: 'Фермопилы',
	},
	{
		id: 'NG_filmic21',
		name: 'Седьмой ряд',
	},
	{
		id: 'NG_filmic22',
		name: 'Конец игры',
	},
	{
		id: 'NG_filmic23',
		name: 'Божественность',
	},
	{
		id: 'NG_filmic24',
		name: 'Чоп',
	},
	{
		id: 'NG_filmic25',
		name: 'Клоуны-убийцы',
	},
];

export enum PhotoModeCurrentMode {
	Control = 'control',
	Edit = 'edit',
}
